import { dateToApiFormat } from '@/helpers/dateHelper';
import { useGetFullRostersQuery } from '@/services/gql/graphql.generated';
import { useLocationService } from '@/services/location/LocationService';

export const useTodayRoster = () => {
  const selectedLocation = useLocationService(s => s.selectedLocation);

  if (!selectedLocation) {
    throw Error('Location must be selected');
  }

  const [{ data }] = useGetFullRostersQuery({
    variables: {
      locationId: selectedLocation.id,
      startDate: dateToApiFormat(new Date()),
      endDate: dateToApiFormat(new Date())
    }
  });

  const rosters = data?.rostersWithPositionsAndTasksInDateRange;
  if (!rosters) {
    throw Error('Unable to get roster data');
  }

  return rosters.length === 0 ? undefined : rosters[0];
};

export const useTodayRosterPositions = () => {
  const roster = useTodayRoster();

  if (!roster) {
    return undefined;
  }

  const stations = roster.stations!;
  const positions = stations[0].positions!;

  return positions;
};
